import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { instructors } from "./InstructorSection";

const Scholarsec = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Find the specific instructor
  const scholar = instructors.find(b => b.id === Number(id));

  if (!scholar) {
    return (
      <div style={{ 
        padding: "40px", 
        backgroundColor: "white", 
        color: "black",
        textAlign: "center",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div>
          <h2>Scholar Not Found</h2>
          <p>The instructor you're looking for doesn't exist.</p>
          <button 
            onClick={() => navigate("/")}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "16px"
            }}
          >
            Go Back to Instructors
          </button>
        </div>
      </div>
    );
  }

  const handleDivClick = () => {
    // Navigate to details page where EXT content can be written
    navigate(`/scholar/${id}/details`);
  };

  const handleBackClick = (e) => {
    e.stopPropagation(); // Prevent triggering the parent div click
    navigate("/");
  };

  return (
    <div 
      onClick={handleDivClick}
      style={{
        padding: "40px 20px",
        backgroundColor: "white",
        color: "black",
        minHeight: "100vh",
        cursor: "pointer",
        transition: "background-color 0.3s ease"
      }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
    >
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        {/* Back Button */}
        <button 
          onClick={handleBackClick}
          style={{
            padding: "10px 20px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            marginBottom: "30px",
            display: "inline-flex",
            alignItems: "center",
            gap: "5px"
          }}
        >
          ← Back to All Instructors
        </button>

        {/* Main Content */}
        <div style={{ 
          display: "flex", 
          gap: "40px",
          marginBottom: "40px",
          flexWrap: "wrap"
        }}>
          {/* Image Section */}
          <div style={{ flex: "1", minWidth: "300px" }}>
            <img 
              src={scholar.image} 
              alt={scholar.name}
              style={{
                width: "100%",
                maxWidth: "400px",
                height: "auto",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
              }}
            />
          </div>
          
          {/* Info Section */}
          <div style={{ flex: "1", minWidth: "300px" }}>
            <h1 style={{ 
              fontSize: "42px", 
              marginBottom: "15px", 
              color: "#333",
              borderBottom: "3px solid #007bff",
              paddingBottom: "10px"
            }}>
              {scholar.name}
            </h1>
            
            <div style={{ marginBottom: "20px" }}>
              <p style={{ fontSize: "18px", color: "#495057", marginBottom: "10px" }}>
                <strong>📅 Experience:</strong> {scholar.exp}
              </p>
              
              <p style={{ fontSize: "18px", color: "#495057", marginBottom: "10px" }}>
                <strong>🌐 Languages:</strong> {scholar.language}
              </p>
              
              {scholar.specialty && (
                <p style={{ fontSize: "18px", color: "#495057", marginBottom: "10px" }}>
                  <strong>⭐ Specialty:</strong> {scholar.specialty}
                </p>
              )}
            </div>
            
            <div style={{ 
              backgroundColor: "#f1f3f5", 
              padding: "20px", 
              borderRadius: "8px",
              marginBottom: "20px"
            }}>
              <h3 style={{ margin: "0 0 10px 0", color: "#333" }}>About</h3>
              <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6", margin: 0 }}>
                {scholar.description}
              </p>
            </div>
          </div>
        </div>

        {/* EXT Content Call to Action */}
        <div style={{
          marginTop: "40px",
          padding: "30px",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "10px",
          textAlign: "center",
          color: "white"
        }}>
          <h2 style={{ fontSize: "28px", marginBottom: "15px" }}>
            📝 Add EXT Content
          </h2>
          <p style={{ fontSize: "18px", marginBottom: "20px", opacity: "0.9" }}>
            Click anywhere on this page to add additional notes, observations, or any EXT content about {scholar.name}
          </p>
          <div style={{
            fontSize: "14px",
            opacity: "0.8",
            display: "flex",
            justifyContent: "center",
            gap: "20px"
          }}>
            <span>✏️ Write notes</span>
            <span>💾 Save content</span>
            <span>📋 View saved EXT</span>
          </div>
        </div>

        {/* Additional Info Cards */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          marginTop: "40px"
        }}>
          <div style={{
            padding: "20px",
            backgroundColor: "#e3f2fd",
            borderRadius: "8px",
            textAlign: "center"
          }}>
            <h3 style={{ margin: "0 0 10px 0", color: "#1976d2" }}>Teaching Style</h3>
            <p style={{ margin: 0, color: "#666" }}>Interactive and student-focused approach</p>
          </div>
          
          <div style={{
            padding: "20px",
            backgroundColor: "#f3e5f5",
            borderRadius: "8px",
            textAlign: "center"
          }}>
            <h3 style={{ margin: "0 0 10px 0", color: "#7b1fa2" }}>Available Times</h3>
            <p style={{ margin: 0, color: "#666" }}>Flexible scheduling available</p>
          </div>
          
          <div style={{
            padding: "20px",
            backgroundColor: "#e8f5e8",
            borderRadius: "8px",
            textAlign: "center"
          }}>
            <h3 style={{ margin: "0 0 10px 0", color: "#388e3c" }}>Student Reviews</h3>
            <p style={{ margin: 0, color: "#666" }}>⭐ 4.9/5 from 100+ students</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Scholarsec;